var map;
var InfoObj = [];

var icons = {
  hp:{
    icon: 'https://cdn.shopify.com/s/files/1/0505/4087/1873/files/HP_Map_White.png?v=1661801227'
  }
};

var markersOnMap = [
  {
    storecode: 'H01',
    placeName: 'Hush Puppies Multiplaza del Este',
    storeAddress: 'CC Multiplaza del Este, 2a Etapa, Curridabat, Local 118',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '22537462',
    whatsapp: '64750873',
    page: 'https://goo.gl/maps/jHbZkBtG8UXuqsSVA',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 9.9171502, 
      lng: -84.0472006
    }],
    type: 'hp'
  },
  {
    storecode: 'H04',
    placeName: 'Hush Puppies Multiplaza Escazú',
    storeAddress: 'San Jose, CC Multiplaza Escazu  Tercer Nivel local #161',
    schedule: 'Lunes a Sábado: 10:00am a 9:00pm<br>Domingo: 10:00am a 8:00pm',
    phone: '22015979',
    whatsapp: '60152240',
    page: 'https://g.page/r/CeCsOvzEPF1TEBM',
    review: 'https://g.page/r/CeCsOvzEPF1TEBM/review',
    zona: 1,
    LatLng: [{
      lat: 9.9445835,
      lng: -84.1504178
    }],
    type: 'hp'
  },
  {
    storecode: 'H05',
    placeName: 'Hush Puppies CC City Mall',
    storeAddress: 'Centro Comercial City Mall, Local 1099 Nivel 1',
    schedule: 'Lunes a Domingo: 10:00am a 8:00pm',
    phone: '62328870',
    whatsapp: '63871560',
    page: 'https://maps.app.goo.gl/mcrRLF9xNYvn8whL7',
    review: '',
    zona: 1,
    LatLng: [{
      lat: 10.0044368,
      lng: -84.2140302
    }],
    type: 'hp'
  }
];  

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("actived");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

function addMarkerInfo(){
  for(var i=0; i < markersOnMap.length; i++){
    var contentString = '<div class="place-name">' + markersOnMap[i].placeName + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
    contentString += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
    if(markersOnMap[i].phone !== "")
    	contentString += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 6%"> (506)' + markersOnMap[i].whatsapp + '</a></div>';
    contentString += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
    if(markersOnMap[i].page !== "")
    	contentString += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
    if(markersOnMap[i].review !== "")
    contentString += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div>';

    const marker = new google.maps.Marker({
      position: markersOnMap[i].LatLng[0],
      icon: icons[markersOnMap[i].type].icon,
      map: map
    });

    const infowindow = new google.maps.InfoWindow({
      content: contentString
    });


    marker.addListener('click', function(){
      closeOtherInfo();
      infowindow.open(marker.get('map'),marker);
      InfoObj[0] = infowindow;
    });
    
    switch (markersOnMap[i].zona) {
      case 1: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 6%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 6%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
      case 2: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info2").innerHTML += contentDiv;
        		break;
      
      case 3: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info3").innerHTML += contentDiv;
        		break;
      
      case 4: 
     			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info4").innerHTML += contentDiv;
        		break;
      
      default:
      			var contentDiv = '<div class="contentDiv" onclick="SetCenterMap('+markersOnMap[i].LatLng[0].lat+','+markersOnMap[i].LatLng[0].lng+')"><div class="place-name">' + markersOnMap[i].placeName + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].storeAddress + '</div>';
                contentDiv += '<div class="place-general">' + markersOnMap[i].schedule + '</div>';
                if(markersOnMap[i].phone !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" href="tel:+506'+markersOnMap[i].phone+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/phone-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%"> (506)'+ markersOnMap[i].phone + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://api.whatsapp.com/send?phone=506'+markersOnMap[i].whatsapp+'"><img src="https://cdn.shopify.com/s/files/1/0346/1893/3307/files/whatsapp-min.png?v=1643988824" alt="Hush Puppies Costa Rica" style="width: 15%">(506)' + markersOnMap[i].whatsapp + '</a></div>';
                contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="https://www.waze.com/ul?ll='+markersOnMap[i].LatLng[0].lat+"%2C"+markersOnMap[i].LatLng[0].lng+'&navigate=yes&zoom=17"><img src="https://cdn.shopify.com/s/files/1/0505/4087/1873/files/Waze.png?v=1661893278" alt="Hush Puppies Costa Rica" style="width: 6%"> Navegar en Waze</a></div>';
                if(markersOnMap[i].page !== "")
                    contentDiv += '<div class="place-link"><a class="place-link" target="_blank" href="'+markersOnMap[i].page+'">Ver mapa</a></div>';
                if(markersOnMap[i].review !== "")
                contentDiv += '<div class="place-link"><button class="btn" style="min-height: 5px;"><a class="place-linkb" target="_blank" href="'+markersOnMap[i].review+'">Agregar Reseña</a></button></div></div>';    

                document.getElementById("add-info").innerHTML += contentDiv;
        		break;
      
    }
  }
}

function closeOtherInfo(){
  if(InfoObj.length > 0){
    InfoObj[0].set("marker", null);
    InfoObj[0].close();
    InfoObj[0].length = 0;
  }
}

function SetCenterMap(posLat, posLon){
  var centerStore = {lat: posLat, lng: posLon};
  map.setCenter(centerStore);
}

function positionOk(pos){
  var latitudeMap = pos.coords.latitude;
  var longitudMap = pos.coords.longitude;
  var centerStore = {lat: latitudeMap, lng: longitudMap};
  map.setCenter(centerStore);
}

function positionKO(){
  const centerStore = {lat: 9.9445835, lng: -84.1504178};
  map.setCenter(centerStore);
}

function initMap(){
  map = new google.maps.Map(document.getElementById('map'),{
    zoom: 15,
    center: {lat: 9.9445835, lng: -84.1504178},
    mapId: '7b2b8c05c9abdb62'
  });

  if(navigator.geolocation){
    navigator.geolocation.getCurrentPosition(positionOk, positionKO);            
  }

  addMarkerInfo();
};

function openPage(pageName,elmnt) {
  var i, tabcontent;
  
  tabcontent = document.getElementsByClassName("tabcontent2");
  
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  };
    
  document.getElementById(pageName).style.display = "block";
  elmnt.style.borderBottom = "6px solid #FF6B00";
}